import { render, staticRenderFns } from "./FollowUpCase.vue?vue&type=template&id=5a146858&"
import script from "./FollowUpCase.vue?vue&type=script&lang=js&"
export * from "./FollowUpCase.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpCase.vue?vue&type=style&index=0&id=5a146858&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports